export const STORE_KEY = '@@route'
export const ROUTE_INIT = `${STORE_KEY}/ROUTE_INIT`
export const ROUTE_CHANGE_START = `${STORE_KEY}/ROUTE_CHANGE_START`
export const ROUTE_CHANGE_COMPLETE = `${STORE_KEY}/ROUTE_CHANGE_COMPLETE`
export const ROUTE_CHANGE_ERROR = `${STORE_KEY}/ROUTE_CHANGE_ERROR`
export const BEFORE_HISTORY_CHANGE = `${STORE_KEY}/BEFORE_HISTORY_CHANGE`
export const HASH_CHANGE_START = `${STORE_KEY}/HASH_CHANGE_START`
export const HASH_CHANGE_COMPLETE = `${STORE_KEY}/HASH_CHANGE_COMPLETE`
